import GroupedContent from 'grouped-content';
import reframe from 'reframe.js';

export default class RTE {
  constructor(el) {
    this.el = el;
    this.groupedContent = new GroupedContent(el, { layout: 'accordion', intelliparse: false });
    this.frames = el.querySelectorAll('iframe');

    reframe(this.frames);
  }

  unload() {
    // Reframe doesnt offer an unload method, so we'll manually remove the elements added
    for (let i = 0; i < this.frames.length; i++) {
      const frame = this.frames[i];
      const wrapper = frame.parentNode;
      const originalParent = wrapper.parentNode;

      originalParent.appendChild(frame);
      originalParent.removeChild(wrapper);
    }

    this.groupedContent.unload();
  }
}
